import { i18n } from "translations";

import { AllowanceBaseOnType, AllowanceReceiveType } from "./types";

export const AllowanceBaseOnTypeOptions = [
  {
    label: "GROSS",
    value: AllowanceBaseOnType.GROSS,
  },
  {
    label: "NET",
    value: AllowanceBaseOnType.NET,
  },
];

export const AllowanceReceiveTypeOptions = [
  {
    label: i18n.t("basedOnPercentage"),
    value: AllowanceReceiveType.PERCENT,
    subLabel: i18n.t(
      "allowanceWillBeCalculatedByAPercentageBasedOnBasedAllowance"
    ),
  },
  {
    label: i18n.t("basedOnActualWorkingDays"),
    value: AllowanceReceiveType.ACTUAL_WORKING_DAY,
    subLabel: i18n.t("allowanceWillBeCalculatedBasedOnTheActualWorkingDays"),
  },
  {
    label: i18n.t("basedOnTotalActualWorkingDays"),
    value: AllowanceReceiveType.TOTAL_WORKING_DAY,
    subLabel: i18n.t(
      "allowanceWillBeCalculatedBasedOnTheTotalActualWorkingDaysIncludingPaidLeaves"
    ),
  },
];
